/** Three concentric amber rings centered on the firefly circle. */
export function ActivityDockGoldenHaloRings({
  centerX,
  centerY,
  diameterPx,
}: {
  centerX: number;
  centerY: number;
  diameterPx: number;
}) {
  return (
    <span
      aria-hidden
      className="pointer-events-none absolute"
      style={{
        left: centerX - diameterPx / 2,
        top: centerY - diameterPx / 2,
        width: diameterPx,
        height: diameterPx,
      }}
    >
      <span className="activity-dock-halo-ring" />
      <span className="activity-dock-halo-ring delay-1" />
      <span className="activity-dock-halo-ring delay-2" />
    </span>
  );
}
